import React, { Fragment, useEffect, useRef } from 'react';
import { TextBox, Button as TextBoxButton } from 'devextreme-react/text-box';
import { Button } from 'devextreme-react/button';
import { makeStyles } from '@material-ui/core/styles';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import SearchIcon from '@material-ui/icons/Search';
import TagBox from 'devextreme-react/tag-box';
import DateBox from 'devextreme-react/date-box';
import TreeSelector from './TreeSelector';

const useStyles = makeStyles({
    root: {
        marginBottom: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        overflow: "hidden",
        marginTop: "10px",
    },
    swicth: {
        marginLeft: "20px"
    },
    display: {
        display: "inline-block !important"
    },
    displayFilters: {
        display: "flex",
        flexDirection: "column"
    },
    labelSwicth: {
        fontSize: "12px !important"
    },
});

export default function TableForm(props) {
    const classes = useStyles();
    const { datos, estados, provinces, defaultStartDate, entryChannels, subEstados } = props;
    const entryChannelTagbox = useRef(null);
    const stateTagbox = useRef(null);
    const subStateTagbox = useRef(null);
    const premiumTagBox = useRef(null);
    const premiumOptions = [{description: "Sí", value: true}, {description:"No", value: false}]

    function showClearFilters() {
        return datos.busquedaGeneral || datos.estado || datos.fechaInicio != defaultStartDate || datos.fechaInicioHasta || datos.taxonomies || datos.entryChannels || datos.subEstados || datos.premium !== null
    }

    function clearFunction() {
        entryChannelTagbox.current?.instance?.reset();
        stateTagbox.current?.instance?.reset();
        subStateTagbox.current?.instance?.reset();
        premiumTagBox.current?.instance?.reset();
        props.clearFilters()
    }

    useEffect(() => {

        const statesWithsubStates = Array.isArray(estados) ? estados.filter((e) => e.subStates.length > 0 && datos.estado?.some((de) => de === e.stateId)) : []
        const reselectedSubStates = datos.subEstados?.filter((substate) => statesWithsubStates?.some(parentState => parentState.subStates?.some(parentSubstates => parentSubstates.subStateId === substate)))

        if (reselectedSubStates?.length === 0) {
            subStateTagbox.current?.instance?.option("value", [])
        }

    }, [datos.estado])

    return (
        <Fragment>
            <form onSubmit={props.handleSubmit} className={classes.root}>
                {props.type !== "Itvs" && props.type !== "Casos" &&
                    <div style={{ width: "20%", float: "left" }}>
                        <TextBox
                            placeholder="Procurar"
                            value={datos.busquedaGeneral}
                            mode="text"
                            onEnterKey={props.type == "Casos" ? props.handleSubmit : null}
                            onValueChange={props.handleInputChange}
                            valueChangeEvent="keyup">
                            <TextBoxButton
                                name="resetar"
                                location="after"
                                options={{
                                    icon: 'clear',
                                    stylingMode: 'text',
                                    visible: datos.busquedaGeneral != '' ? true : false,
                                    onClick: (e) => {
                                        props.handleInputClear(e.event);
                                    }
                                }}
                            />
                            <TextBoxButton
                                name="search"
                                location="after"
                                options={{
                                    icon: 'search',
                                    stylingMode: 'text',
                                    onClick: (e) => {
                                        props.handleSubmit(e.event);
                                    }
                                }}
                            />
                        </TextBox>
                    </div>
                }
                {
                    props.type == "Itvs" &&
                    <Fragment>
                        <div style={{ width: "20%", float: "left" }}>
                            <TextBox
                                placeholder="Procurar"
                                value={datos.busquedaGeneral}
                                mode="text"
                                onEnterKey={props.type == "Casos" ? props.handleSubmit : null}
                                onValueChange={props.handleInputChange}
                                valueChangeEvent="keyup">
                                <TextBoxButton
                                    name="resetar"
                                    location="after"
                                    options={{
                                        icon: 'clear',
                                        stylingMode: 'text',
                                        visible: datos.busquedaGeneral != '' ? true : false,
                                        onClick: (e) => {
                                            props.handleInputClear(e.event);
                                        }
                                    }}
                                />
                                <TextBoxButton
                                    name="search"
                                    location="after"
                                    options={{
                                        icon: 'search',
                                        stylingMode: 'text',
                                        onClick: (e) => {
                                            props.handleSubmit(e.event);
                                        }
                                    }}
                                />
                            </TextBox>
                        </div>
                        <div onKeyPress={props.checkEnter} className={classes.display}>
                            <div style={{ float: "left", width: 200, marginRight: 10, marginLeft: 10 }} className={classes.display}>
                                <TagBox id="custom-provinces"
                                    className="tagStates"
                                    placeholder="Provincias"
                                    searchEnabled={true}
                                    dataSource={provinces}
                                    defaultValue={datos.provincias}
                                    multiline={false}
                                    onValueChanged={props.handleProvinceChange}
                                    items={provinces}
                                    showClearButton={true}>
                                </TagBox>
                            </div>
                        </div>
                    </Fragment>
                }
                {
                    props.type == "Casos" &&
                    <Fragment>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                            <div onKeyPress={props.checkEnter} className={classes.displayFilters}>
                                <div>
                                    <div style={{ width: "19.5vw", minWidth: 210, float: "left" }}>
                                        <TextBox
                                            placeholder="Procurar"
                                            value={datos.busquedaGeneral}
                                            mode="text"
                                            onEnterKey={props.type == "Casos" ? props.handleSubmit : null}
                                            onValueChange={props.handleInputChange}
                                            valueChangeEvent="keyup">
                                            <TextBoxButton
                                                name="resetar"
                                                location="after"
                                                options={{
                                                    icon: 'clear',
                                                    stylingMode: 'text',
                                                    visible: datos.busquedaGeneral != '' ? true : false,
                                                    onClick: (e) => {
                                                        props.handleInputClear(e.event);
                                                    }
                                                }}
                                            />
                                        </TextBox>
                                    </div>
                                    <div style={{ float: "left", width: 190, marginLeft: 10 }} className={classes.display}>
                                        <TagBox id="custom-templates"
                                            ref={entryChannelTagbox}
                                            defaultValue={datos.entryChannels ? [].concat(datos.entryChannels) : []}
                                            className="tagEntryChannel"
                                            placeholder="Canal de entrada"
                                            selectAllText="Selecionar todos"
                                            dataSource={entryChannels}
                                            showSelectionControls={true}
                                            multiline={false}
                                            applyValueMode="instantly"
                                            displayExpr="description"
                                            onValueChanged={props.handleEntryChannelChange}
                                            valueExpr="entryChannelId"
                                            items={entryChannels}
                                            showClearButton={true}>
                                        </TagBox>
                                    </div>
                                    <div style={{ float: "left", width: 190, marginLeft: 10 }} className={classes.display}>
                                        <TagBox id="custom-templates"
                                            ref={stateTagbox}
                                            defaultValue={datos.estado ? [].concat(datos.estado) : []}
                                            className="tagStates"
                                            placeholder="Estados"
                                            selectAllText="Selecionar todos"
                                            dataSource={estados}
                                            showSelectionControls={true}
                                            multiline={false}
                                            applyValueMode="instantly"
                                            displayExpr="description"
                                            onValueChanged={props.handleBoxChange}
                                            valueExpr="stateId"
                                            items={estados}
                                            showClearButton={true}>
                                        </TagBox>
                                    </div>
                                    {/* <div style={{ float: "left", width: 190, marginLeft: 10 }} className={classes.display}>
                                        <TagBox id="custom-templates"
                                            ref={subStateTagbox}
                                            defaultValue={datos.subEstados ? [].concat(datos.subEstados) : []}
                                            className="tagStates"
                                            placeholder="Subestados"
                                            selectAllText="Seleccionar todos"
                                            noDataText='No hay subestados'
                                            dataSource={subEstados}
                                            grouped={true}
                                            showSelectionControls={true}
                                            multiline={false}
                                            applyValueMode="instantly"
                                            displayExpr="description"
                                            onValueChanged={props.handleSubStateChange}
                                            valueExpr="subStateId"
                                            showClearButton={true}>
                                        </TagBox>
                                    </div> */}
                                </div>
                                <div style={{ marginTop: "10px" }}>
                                    <div style={{ width: "19.5vw", minWidth: 210, display: "inline-block" }} >
                                        <TreeSelector selectNodesRecursive={true} selectAllText="Selecionar todas" taxonomies={datos.taxonomies} onSelectionChanged={props.handleTaxonomiesChange} ></TreeSelector>
                                    </div>
                                    <div style={{ width: 190, marginRight: 10, marginLeft: 10 }} className={classes.display}>
                                        <DateBox
                                            className="dateCases"
                                            placeholder="Data de início a partir de"
                                            showClearButton={true}
                                            useMaskBehavior={true}
                                            dateSerializationFormat="yyyy-MM-dd"
                                            displayFormat="dd/MM/yyyy"
                                            max={datos.fechaInicioHasta}
                                            value={datos.fechaInicio}
                                            onValueChanged={props.handleFechaIniChange}
                                            onEnterKey={props.checkEnter}
                                            acceptCustomValue={false}
                                            onContentReady={(e) => {
                                                let parent = e.component._$textEditorInputContainer;
                                                parent.children()[0].disabled = true;
                                            }}
                                        />
                                    </div>
                                    <div style={{ width: 190 }} className={classes.display}>
                                        <DateBox
                                            placeholder="Data de início até"
                                            className="dateCases"
                                            showClearButton={true}
                                            useMaskBehavior={true}
                                            min={datos.fechaInicio}
                                            value={datos.fechaInicioHasta}
                                            dateSerializationFormat="yyyy-MM-dd"
                                            displayFormat="dd/MM/yyyy"
                                            acceptCustomValue={false}
                                            onContentReady={(e) => {
                                                let parent = e.component._$textEditorInputContainer;
                                                parent.children()[0].disabled = true;
                                            }}
                                            onEnterKey={props.checkEnter}
                                            onValueChanged={props.handleFechaInicioHastaChange} />
                                    </div>
                                    {/* <div  style={{ width: 190, marginLeft: 10 }} className={classes.display}>
                                        <TagBox id="custom-templates"
                                            ref={premiumTagBox}
                                            defaultValue={datos.premium ? [].concat(datos.premium) : []}
                                            className="tagPremium"
                                            placeholder="Premium"
                                            selectAllText="Seleccionar todos"
                                            dataSource={premiumOptions}
                                            showSelectionControls={true}
                                            multiline={false}
                                            applyValueMode="instantly"
                                            displayExpr="description"
                                            onValueChanged={props.handlePremiumChange}
                                            valueExpr="value"
                                            items={premiumOptions}
                                            showClearButton={true}>
                                        </TagBox>
                                    </div> */}
                                </div>
                            </div>

                            <div style={{ cursor: 'pointer', marginLeft: 30 }} className={classes.display}>
                                <SearchIcon style={{ verticalAlign: 'middle', color: '#3B5158' }} onClick={props.handleSubmit} />
                            </div>
                            {showClearFilters() &&
                                <div style={{ cursor: 'pointer', marginLeft: 30 }} className={classes.display}>
                                    <DeleteOutlinedIcon style={{ verticalAlign: 'middle', color: '#3B5158' }} onClick={clearFunction} />
                                </div>}

                        </div>
                    </Fragment>
                }
                <div>
                {props.type !== "Itvs" &&
                    <div style={{ display: "inline-block" }}>
                        <Button
                            style={{ float: "right", marginRight: "10px" }}
                            onClick={(e) => props.exportExcel(e)}
                            disabled={props.loadingExport}
                            icon="exportxlsx"
                            text="Exportar"
                        />
                    </div>
                }
                {props.type === "Casos" &&
                    <div style={{ display: "inline-block" }}>
                        <Button
                            style={{ float: "right", marginRight: "10px" }}
                            onClick={(e) => props.exportExcel(e, 'Comentarios')}
                            disabled={props.loadingExport}
                            icon="exportxlsx"
                            text="Exportar comentários"
                        />
                    </div>
                }
                </div>
            </form>
        </Fragment>
    )
}